"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateExperimentRequestToJSON = exports.UpdateExperimentRequestFromJSONTyped = exports.UpdateExperimentRequestFromJSON = exports.instanceOfUpdateExperimentRequest = void 0;
var runtime_1 = require("../runtime");
var ExperimentType_1 = require("./ExperimentType");
var Survey_1 = require("./Survey");
/**
 * Check if a given object implements the UpdateExperimentRequest interface.
 */
function instanceOfUpdateExperimentRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateExperimentRequest = instanceOfUpdateExperimentRequest;
function UpdateExperimentRequestFromJSON(json) {
    return UpdateExperimentRequestFromJSONTyped(json, false);
}
exports.UpdateExperimentRequestFromJSON = UpdateExperimentRequestFromJSON;
function UpdateExperimentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, ExperimentType_1.ExperimentTypeFromJSON)(json['type']),
        'startDate': !(0, runtime_1.exists)(json, 'start_date') ? undefined : (json['start_date'] === null ? null : new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (json['end_date'] === null ? null : new Date(json['end_date'])),
        'underivedStatus': !(0, runtime_1.exists)(json, 'underived_status') ? undefined : json['underived_status'],
        'survey': !(0, runtime_1.exists)(json, 'survey') ? undefined : (0, Survey_1.SurveyFromJSON)(json['survey']),
    };
}
exports.UpdateExperimentRequestFromJSONTyped = UpdateExperimentRequestFromJSONTyped;
function UpdateExperimentRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'type': (0, ExperimentType_1.ExperimentTypeToJSON)(value.type),
        'start_date': value.startDate === undefined ? undefined : (value.startDate === null ? null : value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate === null ? null : value.endDate.toISOString()),
        'underived_status': value.underivedStatus,
        'survey': (0, Survey_1.SurveyToJSON)(value.survey),
    };
}
exports.UpdateExperimentRequestToJSON = UpdateExperimentRequestToJSON;
